'use client';
import { useEffect, useState } from 'react';
import { Dimensions, Platform, StatusBar } from 'react-native';

const useScreenDimensions =() =>{
  const [screenDimensions, setScreenDimensions] = useState(getScreenDimensions());

  useEffect(() => {
    const updateScreenDimensions = () => {
      setScreenDimensions(getScreenDimensions());
    };
    updateScreenDimensions();
    if (Platform.OS === 'android' || Platform.OS === 'ios') {
      Dimensions.addEventListener('change', updateScreenDimensions);
    } else {
      window.addEventListener('resize', updateScreenDimensions);
      return () => {
        window.removeEventListener('resize', updateScreenDimensions);
      };
    }
  }, []);

  function getScreenDimensions() {
    if (Platform.OS === 'android' || Platform.OS === 'ios') {
      const { width, height } = Dimensions.get('window');
      const safeInsetHeight =
        Platform.OS === 'android' ? height + StatusBar.currentHeight! : height;
      return { width, height };
    } else if (typeof window === 'object') {
      return { width: window.innerWidth || 0, height: window.innerHeight || 0 };
    } else {
      // You can provide default values or handle the case differently
      return { width: 0, height: 0 };
    }
  }

  return screenDimensions;
}
export default useScreenDimensions;